import type { ReactNode } from 'react';
import React, { useMemo, createContext } from 'react';

import type { ProductCollectionDealsItem } from '../../../../types';

export const DealsContext = createContext<{
  getDealDiffPercentage: (productId: number) => number | undefined;
}>({
  getDealDiffPercentage: () => undefined,
});

type DealsContextWrapperProps = {
  dealsItems: ProductCollectionDealsItem[];
  children: ReactNode;
};
export const DealsContextWrapper = ({
  children,
  dealsItems,
}: DealsContextWrapperProps) => {
  const contextValue = useMemo(
    () => ({
      getDealDiffPercentage: (productId: number) =>
        dealsItems.find(item => item.productId === productId)?.diffPercentage,
    }),
    [dealsItems]
  );

  return (
    <DealsContext.Provider value={contextValue}>
      {children}
    </DealsContext.Provider>
  );
};
